export default {"src":"https://marketplace-web-assets.vinted.com/_next/static/media/ro.ab0ff8ae.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};